import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderModule } from '../header/header.module';
import { HomeModule } from '../home/home.module';
import { RouterModule } from '@angular/router';
import { ClaimsAcknowledgementReportComponent } from './claims-acknowledgement-report/claims-acknowledgement-report.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PendingCancellationReportComponent } from './pending-cancellation-report/pending-cancellation-report.component';

@NgModule({
  declarations: [ClaimsAcknowledgementReportComponent, PendingCancellationReportComponent],
  imports: [
    CommonModule,
    NgbModule,
    HeaderModule,
    HomeModule,
    RouterModule
  ],
  exports: [ClaimsAcknowledgementReportComponent]
})
export class ReportsModule { }